export default "__VITE_ASSET__BgiWBi_y__"